import "./Headline.css";

const Headline = () => {
  return (
    <div className="headline">
      <h2 className="headline__title">Have productive meetings with ease.</h2>
      <p className="headline__text">
        Get all of your projects, choices, and meeting minutes in
        <span>
          <br />
          one location. Instantly send them to everyone. Export
        </span>
        <br />
        <span>them to each of your current tools.</span>
      </p>
    </div>
  );
};

export default Headline;
